module.exports = __webpack_public_path__ + "static/media/rit.6dd5dcf7.png";